import {
  FirestoreNotamFeature,
  NOTAM,
  NOTAMPurpose,
  NOTAMScope,
  NOTAMTraffic,
  NOTAM_TYPE_OTHER,
  ValidIATACode,
  ValidICAOCode,
  isIATACode,
  isICAOCode,
} from "@weatheredstrip/shared";
import { Search } from "history";
import queryString from "query-string";

export const extractStationsFrom = (search: Search): string[] => {
  const rawStations = queryString.parse(search).stations;

  let stationsArray: string[];

  if (Array.isArray(rawStations)) {
    stationsArray = rawStations;
  } else if (typeof rawStations === "string") {
    stationsArray = rawStations
      .split(/(\s|,)/)
      .filter((station) => station !== " ");
  } else {
    stationsArray = [];
  }

  return stationsArray.map((station) => station.toUpperCase());
};

const validateStationCode = (stations: string): boolean => {
  return isIATACode(stations) || isICAOCode(stations);
};

export const filterStationCodes = (
  stations: string[]
): (ValidICAOCode | ValidIATACode)[] => {
  return stations.filter((potentialCode) =>
    validateStationCode(potentialCode)
  ) as (ValidICAOCode | ValidIATACode)[];
};

export function convertFirestoreNotamFeatureToNotam(
  feature: FirestoreNotamFeature
): NOTAM {
  const { coreNOTAMData } = feature.properties;
  const { notam, notamTranslation: notamTranslations } = coreNOTAMData;

  const notamTranslation = notamTranslations[0];

  let text: string;
  if (notam.text) {
    text = notam.text;
  } else if (notamTranslation.type === "ICAO") {
    text = notamTranslation.formattedText;
  } else if (notamTranslation.type === "LOCAL_FORMAT") {
    text = notamTranslation.simpleText;
  } else {
    text = "";
  }

  return {
    code: notam.id || "",
    purpose: notam.purpose || NOTAMPurpose.MISCELLANEOUS,
    scope: notam.scope || NOTAMScope.CHECKLIST,
    traffic: notam.traffic || NOTAMTraffic.CHECKLIST,
    endValidity: notam.effectiveEnd,
    isEndEstimated: /\d{10}-\d{10}EST/.test(text),
    link: "",
    notam: text,
    startValidity: notam.effectiveStart,
    station: notam.icaoLocation,
    title: `GPS ${notam.number}`,
    type: NOTAM_TYPE_OTHER,
  };
}
